import { getId } from '@common/utils/brandDiffsUtils';
import StoreGetDirections from '@components/storelocator/StoreGetDirections';
import React from 'react';
import { useTranslation } from 'react-i18next';
const StoreAddress = (props) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const brandId = getId();
    const { store, hidename, showphone, showmail, showdirections, showHours } = props;
    if (!store) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("address", { className: "store-details", "data-boutiqueid": store.ID },
        !hidename && React.createElement("span", { className: "name" }, store.name),
        brandId === 'MO' ? (React.createElement(React.Fragment, null,
            store.countryCode.value != 'JP' && React.createElement("span", { className: "address" }, `${store.address1 || ''} ${store.address2 || ''} `),
            React.createElement("span", { className: "address2" },
                store.postalCode,
                " ",
                store.countryCode.value === 'JP' ? (_a = store.countryCode) === null || _a === void 0 ? void 0 : _a.displayValue : '',
                " ",
                store.city,
                ' ',
                store.countryCode.value === 'US' || store.countryCode.value === 'CA' ? store === null || store === void 0 ? void 0 : store.stateCode : '',
                " ",
                store.countryCode.value != 'JP' ? (_b = store.countryCode) === null || _b === void 0 ? void 0 : _b.displayValue : ''),
            store.countryCode.value === 'JP' && React.createElement("span", { className: "address" }, `${store.address1 || ''} ${store.address2 || ''} `))) : (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "address" },
                React.createElement(React.Fragment, null,
                    store.countryCode.value != 'JP' && `${store.address1 || ''} ${store.address2 || ''} `,
                    props.split && React.createElement("br", null),
                    store.postalCode,
                    " ",
                    store.countryCode.value === 'JP' ? (_c = store.countryCode) === null || _c === void 0 ? void 0 : _c.displayValue : '',
                    " ",
                    store.city,
                    ' ',
                    store.countryCode.value === 'US' || store.countryCode.value === 'CA' ? store === null || store === void 0 ? void 0 : store.stateCode : '',
                    ' ',
                    store.countryCode.value != 'JP' ? (_d = store.countryCode) === null || _d === void 0 ? void 0 : _d.displayValue : '')),
            store.countryCode.value === 'JP' && React.createElement("span", { className: "address" }, `${store.address1 || ''} ${store.address2 || ''} `))),
        showphone && store.phone && (React.createElement("a", { href: `tel:${store.phone}`, className: "telephone" }, store.phone)),
        showmail && store.email && (React.createElement("a", { target: "_blank", rel: "noreferrer", href: `mailto:${store.email}`, className: "email" }, store.email)),
        showdirections && React.createElement(StoreGetDirections, { store: store }),
        showHours && store.storeHours && (React.createElement("div", { className: "store-details__hours" },
            React.createElement("span", { className: "store-details__title" }, t('label.storeHours')),
            React.createElement("dl", null, store.storeHours.map((sh) => (React.createElement(React.Fragment, { key: sh.day },
                React.createElement("dt", null, sh.day),
                React.createElement("dd", null, sh.text)))))))));
};
export default StoreAddress;
